import ArmsRum from '@arms/rum-browser'

export default defineNuxtPlugin(nuxtApp => {
  const { appEnv } = useRuntimeConfig().public
  if (appEnv === 'prod') {
    ArmsRum.init({
      pid: 'jkfap0wav0@47e4d4f6922f68e',
      endpoint: 'https://jkfap0wav0-default-cn.rum.aliyuncs.com'
    })
  }
})
